<template>
  <div class="text-center">
    <v-tooltip left>
      <template
        v-if="invitationType === 'byGroup' || invitationType === 'byStudent'"
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          color="primary"
          dark
          small
          fixed
          bottom
          right
          fab
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Activar Licencia</span>
    </v-tooltip>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template
        v-if="invitationType === 'byLicense'"
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          small
          :disabled="item.state != 'Disponible'"
          v-on="on"
        >
          Activar
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          v-if="$route.name === 'Mis Productos'"
          class="headline grey lighten-2 text-left"
        >
          Activar Licencia
        </v-card-title>

        <v-card-title
          v-if="$route.name === 'Estudiantes'"
          class="headline grey lighten-2 text-left"
        >
          Activar Licencia
        </v-card-title>

        <v-card-text>
          Invita a tus estudiantes para que puedan jugar.
          <v-form
            ref="form"
            lazy-validation
            class="py-4 text-center"
          >
            <v-text-field
              v-model="email"
              label="Email"
              class="purple-input"
              prepend-icon="mdi-email"
              :rules="emailRules"
              outlined
            />
          </v-form>
          <p v-if="invitationType === 'byLicense'">
            Licencia: {{ item.license }}
          </p>
          <p v-if="invitationType === 'byGroup'">
            Grupo: {{ item.nameGroup }}
          </p>

          <v-select
            v-if="invitationType === 'byLicense' || invitationType === 'byStudent'"
            v-model="groupSelect"
            :items="groups"
            label="Seleccione Grupo"
            outlined
            prepend-icon="mdi-account-group-outline"
            item-text="name"
            :rules="groupSelectRules"
          />

          <v-select
            v-if="invitationType === 'byGroup' || invitationType === 'byStudent'"
            v-model="licenseSelect"
            :items="licensesAvailable"
            label="Seleccione Licencia"
            outlined
            prepend-icon="mdi-account-group-outline"
            item-text="id"
            :rules="licenseSelectRules"
          />

          <v-subheader>La activación se completará cuando el jugador registre sus datos.</v-subheader>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="studentEmailSet"
          >
            {{ textBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      invitationType: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        textBtn: 'Procesar',
        dialog: false,
        email: '',
        emailRules: [
          value => !!value || 'Email es requerido.',
          value => (value || '').length <= 50 || 'Max 50 caracteres',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email invalido.'
          },
        ],
        groupSelectRules: [v => !!v || 'Grupo es requerido (Debes crear un grupo.)'],
        licenseSelectRules: [v => !!v || 'Licencia es requerido'],
        groupSelect: null,
        licenseSelect: null,
        sendStudentEmail_url: 'https://us-central1-videojuego-sh.cloudfunctions.net/sendStudentEmail',
      }
    },
    computed: {
      ...mapState(['userData', 'user', 'licenses']),
      groups () {
        return this.userData.groups
      },
      licensesAvailable () {
        return this.licenses.filter(l => l.player_uid === '')
      },
    },
    watch: {
      dialog (val) {
        if (this.groups.length > 0) {
          this.groupSelect = this.userData.groups[0].name
        } else {
          this.groupSelect = null
        }

        if (this.licensesAvailable.length > 0) {
          this.licenseSelect = this.licensesAvailable[0].id
        } else {
          this.licenseSelect = null
        }
      },
    },
    methods: {
      close () {
        this.textBtn = 'Procesar'
        this.$refs.form.reset()
        this.dialog = false
      },
      async studentEmailSet () {
        if (this.$refs.form.validate()) {
          this.textBtn = 'Procesando...'
          this.$store.commit('SET_LOADING', true)
          try {
            var groupId = ''
            var licenseId = ''
            if (this.invitationType === 'byGroup') {
              groupId = this.groups.findIndex(group => group.name === this.item.nameGroup)
              licenseId = this.licenseSelect
            } else if (this.invitationType === 'byLicense') {
              groupId = this.groups.findIndex(group => group.name === this.groupSelect)
              licenseId = this.item.license
            } else {
              groupId = this.groups.findIndex(group => group.name === this.groupSelect)
              licenseId = this.licenseSelect
            }

            const response = await axios
              .post(this.sendStudentEmail_url, {
                uid: this.user.uid,
                email: this.email,
                groupId,
                licenseId,
              })

            const message = response.data.message
            alert(message)
            this.$store.commit('SET_LOADING', false)
          } catch (error) {
            this.$store.commit('SET_LOADING', false)
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            alert(errorMessage)
          }
          this.close()
        } else {
          console.log('Faltan datos')
          this.$store.commit('SET_LOADING', false)
        }
      },
    },
  }
</script>
